import {formatProductResultSummary} from '../product-results/format-product-result-summary';

export const PRODUCTS_LOAD_ERROR = 'We could not load products. Please try again.';
export const PREVIOUS_SEARCH_MESSAGE = 'These products are from the previous successful search.';

export type StoreProductsStatus = {
    loading: boolean;
    hasLoadedSuccessfully: boolean;
    errorMessage: string;
    hasProducts: boolean;
    shownCount: number;
    totalCount: number;
    /** Page that produced the products still on screen. Omitted requests use page 1. */
    acceptedPage?: number;
};

export function getStoreProductsStatusText({loading, hasLoadedSuccessfully, errorMessage, hasProducts, shownCount, totalCount, acceptedPage = 1}: StoreProductsStatus): string {
    if (loading) {
        if (!hasLoadedSuccessfully) {
            return 'Loading products…';
        }

        return hasProducts ? `Updating products… ${PREVIOUS_SEARCH_MESSAGE}` : 'Updating products…';
    }

    if (errorMessage) {
        return hasProducts ? `${errorMessage} ${PREVIOUS_SEARCH_MESSAGE}` : errorMessage;
    }

    if (hasProducts) {
        return formatProductResultSummary({
            page: acceptedPage,
            total: totalCount,
            visibleCount: shownCount,
        });
    }

    if (hasLoadedSuccessfully) {
        return formatProductResultSummary({
            page: acceptedPage,
            total: 0,
            visibleCount: 0,
        });
    }

    return 'Loading products…';
}

export function shouldShowEmptyResults({loading, hasLoadedSuccessfully, errorMessage, hasProducts}: Pick<StoreProductsStatus, 'loading' | 'hasLoadedSuccessfully' | 'errorMessage' | 'hasProducts'>): boolean {
    return hasLoadedSuccessfully && !hasProducts && !loading && !errorMessage;
}

export function isResultsBusy({loading, hasLoadedSuccessfully, errorMessage}: Pick<StoreProductsStatus, 'loading' | 'hasLoadedSuccessfully' | 'errorMessage'>): boolean {
    return loading || (!hasLoadedSuccessfully && !errorMessage);
}
